<template>
    <el-dialog :title="$t('editMerchant')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog"
               top="5vh">
        <div class="content">
            <el-form :model="formData"
                     size="mini"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <h4 class="form-title">{{ $t('basicInfo') }}</h4>
                <el-form-item :label="$t('merchantName')"
                              prop="name">
                    <el-input v-model="formData.name"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('website')"
                              prop="website">
                    <el-input v-model="formData.website"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('brand')"
                              prop="brand">
                    <el-input v-model="formData.brand"
                              @input.native="brandDebounce"></el-input>
                </el-form-item>
                <el-form-item :label="$t('describe')"
                              prop="description">
                    <el-input type="textarea" v-model="formData.description"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Logo" prop="logo">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequestLogo"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.logo" class="avatar" v-if="formData.logo">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveLogo" v-if="formData.logo"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
                <h4 class="form-title bd-top">{{ $t('advertInfo') }}</h4>
                <el-form-item :label="$t('advertClassify')"
                              prop="showcaseCategoryIds">
                    <el-select
                        v-model="formData.showcaseCategoryIds"
                        multiple
                        collapse-tags
                        filterable>
                        <el-option
                            v-for="item in classifyOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Banner" prop="banner">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequestBanner"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.banner" class="avatar" v-if="formData.banner">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveBanner" v-if="formData.banner"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
                <h4 class="form-title bd-top">{{ $t('memberCardInfo') }}</h4>
                <el-form-item :label="$t('whetherRecom')" prop="recommend">
                    <el-radio-group v-model="formData.recommend">
                        <el-radio :label="true">{{ $t('yes') }}</el-radio>
                        <el-radio :label="false">{{ $t('no') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('bgColor')"
                              prop="background">
                    <el-color-picker v-model="formData.background"></el-color-picker>
                </el-form-item>
                <el-form-item :label="$t('memberCardIcon')" prop="logo">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequestCard"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.cardIcon" class="avatar" v-if="formData.cardIcon">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveCard" v-if="formData.cardIcon"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button
                size="mini"
                @click="dialogVisible = false">{{ $t('cancel') }}
            </el-button>
            <el-button
                type="primary"
                size="mini"
                :disabled="disabled"
                @click="submitForm('ruleForm')">{{ $t('confirm') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    searchAdvertClassifyList,
    queryMerchantDetails,
    updateMerchant,
    uploadImage,
    merchantBrandCheckBrand
} from "@/api/modules/api";
import {Debounce} from "@/utils/common";

export default {
    name: 'Edit',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        let checkBrand = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('pleaseInputHint')))
            }
            if (this.brandUsable) {
                callback()
            } else {
                callback(new Error(this.$t('brandRepeat')));
            }
        };
        return {
            dialogVisible: false,
            classifyOptions: [],
            formData: {
                name: '',
                website: '',
                brand: '',
                description: '',
                logo: '',
                showcaseCategoryIds: [],
                banner: '',
                recommend: false,
                background: '#FFFFFF',
                cardIcon: '',
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                brand: [{ required: true, validator: checkBrand, trigger: 'blur' }],
                logo: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                showcaseCategoryIds: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                banner: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                recommend: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                background: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            brandUsable: false,  // 品牌是否可用
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
            // 获取广告分类列表
            if (this.classifyOptions.length === 0) {
                this.getClassifyOptions()
            }
        },
    
        // 获取详情
        getDetails () {
            queryMerchantDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    let showcaseCategoryIds = resData.showcaseCategorys.map(item => item.id)
                    this.formData = {
                        name: resData.name,
                        recommend: resData.recommend,
                        background: resData.background,
                        showcaseCategoryIds,
                        website: resData.website || '',
                        brand: resData.brand || '',
                        description: resData.description || '',
                        logo: resData.logo,
                        banner: resData.banner,
                        cardIcon: resData.cardIcon
                    }
                    if (resData.brand) {
                        this.brandUsable = true
                    } else {
                        this.brandUsable = false
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
    
        // 校验编码是否重复
        brandDebounce: Debounce(function () {
            if (!this.formData.brand) {
                this.$refs.ruleForm.validateField('brand')
                return;
            }
            const params = {
                id: this.parentId,
                brand: this.formData.brand.trim()
            }
            merchantBrandCheckBrand(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.brandUsable = !res.data.duplicate
                    this.$refs.ruleForm.validateField('brand')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            })
        }, 500),
    
        // 获取广告分类列表
        getClassifyOptions() {
            const params = {
                type: 101
            }
            searchAdvertClassifyList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.classifyOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        /******** Logo图片 ********/
        httpRequestLogo(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.logo = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                this.$message.error(err);
            })
        },
        // 清除图片
        handleRemoveLogo () {
            this.formData.logo = ''
        },
    
        /******** Banner图片 ********/
        httpRequestBanner(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.banner = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                this.$message.error(err);
            })
        },
        // 清除图片
        handleRemoveBanner () {
            this.formData.banner = ''
        },
    
        /******** 会员卡Icon ********/
        httpRequestCard(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.cardIcon = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                this.$message.error(err);
            })
        },
        // 清除图片
        handleRemoveCard () {
            this.formData.cardIcon = ''
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            const params = {
                id: this.parentId,
                name: this.formData.name.trim(),
                recommend: this.formData.recommend,
                background: this.formData.background,
                showcaseCategoryIds: this.formData.showcaseCategoryIds,
                website: this.formData.website,
                brand: this.formData.brand,
                description: this.formData.description,
                logo: this.formData.logo,
                banner: this.formData.banner,
                cardIcon: this.formData.cardIcon
            }
            this.disabled = true;
            updateMerchant(params).then((res) => {
                this.disabled = false;
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.disabled = false;
                this.$message.error(err);
            });
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
.content{
    .form-title{
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
    }
}
</style>
